import { ITags } from "@formant/core/model/ITags";
import { Uuid } from "@formant/core/model/Uuid";

/** Tag keys that have more than 1 value for a single device */
export function multiValuedTagKeys(
    data: { deviceId: Uuid; tags: ITags }[],
): string[] {
    const deviceKeys = new Map<Uuid, Set<string>>();

    for (const { deviceId, tags } of data) {
        const keys = deviceKeys.get(deviceId) || new Set();
        deviceKeys.set(deviceId, keys);
        Object.keys(tags).forEach(_ => keys.add(_));
    }

    const results: Map<Uuid, Map<string, Set<string | undefined>>> = new Map();

    for (const { deviceId, tags } of data) {
        const keyValues = results.get(deviceId) || new Map();
        results.set(deviceId, keyValues);

        for (const key of deviceKeys.get(deviceId) || []) {
            const values = keyValues.get(key) || new Set();
            keyValues.set(key, values);
            values.add(tags[key]);
        }
    }

    return [
        ...new Set(
            [...results.values()].flatMap(keyValues =>
                [...keyValues.keys()].filter(
                    key => (keyValues.get(key)?.size || 0) > 1,
                ),
            ),
        ),
    ].sort();
}
